import { defineComponent as _defineComponent } from 'vue'
import DialogoDeConfirmacao from '@/components/dialogos/DialogoDeConfirmacao.vue'
import { computed, defineComponent, ref } from 'vue'
import { InputIrmao } from 'common/types/Irmao'
import IrmaoService from '@/services/IrmaoService'
import ConviteService from '@/services/ConviteService'
import { alert, authModule, userModule } from '@/store'
import { useMutation } from '@tanstack/vue-query'
import DialogoDeExclusao from '@/components/dialogos/DialogoDeExclusao.vue'
import { intersectRoles } from '@/../common/shareds/sharedAuth'
import { emailValido } from '@/shareds/regras'
import { useRouter } from 'vue2-helpers/vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSeguranca',
  props: {
    novo: { type: Boolean },
    value: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
	novo: boolean, 
	value: InputIrmao
};

defineComponent({
	inheritAttrs: true,
})





const mostraExclusao = ref(false);

const dialogoDeConfirmacao = ref<InstanceType<typeof DialogoDeConfirmacao>>()

const podeEnviarLink = computed(() => !!userModule.currentUser?.secretarioDeInformatica
	|| intersectRoles(authModule.role, ['admin', 'admin-potencia', 'admin-loja']))

const { mutate: enviarLink, isPending } = useMutation({
	mutationFn: async () => {
		if (!props.value._id) throw new Error('Irmão não possui ID')

		return ConviteService.enviar(props.value._id)
	},
	onSuccess() {
		alert.setSuccess('Link de senha enviado')
	},
	onError(error) {
		alert.setError(error)
	}
})

async function confirmarEnviarLink() {
	const confirmado = await dialogoDeConfirmacao.value?.abrir()
	if (!confirmado) return

	enviarLink()
}

const router = useRouter()

const { mutateAsync: excluirIrmao, isPending: excluindo } = useMutation({
    mutationFn: () => IrmaoService.remove(props.value._id!),
    onSuccess() {
        alert.setSuccess('Irmão removido com sucesso')
        router.push({ name: 'home' })
    }
})

return { __sfc: true,props, emit, mostraExclusao, dialogoDeConfirmacao, podeEnviarLink, enviarLink, isPending, confirmarEnviarLink, router, excluirIrmao, excluindo, DialogoDeConfirmacao, authModule, DialogoDeExclusao, intersectRoles, emailValido }
}

})